import React from 'react';
import { FileTextIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { BRAND, CORE_PROMISE } from '../../data/salesContent';
const badges = [{
  label: '3 volúmenes + 5 bonos',
  icon: BookOpenIcon
}, {
  label: '100% digital',
  icon: FileTextIcon
}, {
  label: 'Acceso inmediato',
  icon: ZapIcon
}];
export function HeroSection() {
  return <header className="bg-ink px-5 pb-20 pt-12 md:pb-28 md:pt-16" style={{
    backgroundImage: 'radial-gradient(ellipse 70% 50% at 50% 30%, rgba(212,175,55,0.08), transparent 70%)'
  }} data-id="element-132" data-mp="1nj7tv5la0rr8">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-133" data-mp="1dks2d1ic7gh7">
        <p className="font-display text-sm font-extrabold uppercase tracking-[0.25em] text-gold md:text-base" data-id="element-134" data-mp="1dip3drz7id0c">{BRAND}</p>
        <h1 className="mt-6 font-display text-5xl font-black leading-[1.05] text-cream md:text-7xl" style={{
        fontSize: "40px"
      }} data-id="element-135" data-mp="14k3ktwtqixzk">
          Dejá de preparar cada capacitación
          <span className="block text-gold" data-id="element-136" data-mp="31mb4jqa4jnnq">desde cero.</span>
        </h1>

        <ProductImage className="mt-10 w-full max-w-xl" data-id="element-137" data-mp="36g5lwn29bqjn" />

        <p className="mt-8 font-display text-xl font-extrabold text-gold md:text-2xl" data-id="element-138" data-mp="2so8y2v7mg2t2">Primeros Auxilios para Instructores™</p>
        <p className="mt-3 max-w-2xl text-lg leading-relaxed text-neutral-300 md:text-xl" data-id="element-139" data-mp="2wpkqt9lsl45h">
          Qué enseñar, cómo explicarlo, cómo hacerlo practicar y cómo evaluar. Todo en un solo sistema.
        </p>
        <ul className="mt-6 flex flex-wrap justify-center gap-3" data-id="element-140" data-mp="3pd6wcnekyiuz">
          {badges.map(({
          label,
          icon: Icon
        }) => <li key={label} className="flex items-center gap-2 rounded-full border border-ink-line bg-ink-soft px-4 py-2 text-sm font-semibold text-cream md:text-base" data-id="element-141" data-mp="3gd0k14umboxe">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-142" data-mp="1zxh6yc5ey4cl" />
              {label}
            </li>)}
        </ul>

        <div className="mt-12 w-full max-w-2xl" data-id="element-143" data-mp="24viqey6r45ol">
          <p className="font-display text-lg font-extrabold uppercase tracking-wide text-gold md:text-xl" data-id="element-144" data-mp="agloqngek0o1">{CORE_PROMISE}</p>
          <div className="my-8 h-px w-full bg-ink-line" aria-hidden="true" data-id="element-145" data-mp="5jbyx6p3pmzo" />
          <PriceBlock lead="Hoy por" data-id="element-146" data-mp="qivqn9a6mpp" />
          <div className="mt-8" data-id="element-147" data-mp="ph7fh3983q1">
            <CtaButton note="Acceso a los 3 volúmenes + 5 bonos" data-id="element-148" data-mp="3sw5yz1rgzn44">Quiero el sistema completo</CtaButton>
          </div>
        </div>
      </div>
    </header>;
}